export default {
  bind: function (el) {
    el.style.whiteSpace = "pre-wrap";
    el.style.wordBreak = "break-all";
  },
};
